<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <!-- <button class="btn btn-primary" @click="toggleMenu">Toggle Menu</button> -->
      <i class='bx bx-menu' @click="toggleMenu"></i>

      <div class="avatar">
        <i class='bx bx-bell'></i>
        <img src="../../assets/images/avatar/avatar-1.jpg" width="45" @click="toggleProfile">
        <!-- crear un dropwn con el perfil y logout debajo de la imagen -->
        <div id="profile" class="profile">             
            <a class="dropdown-item" href="#"><i class="bx bx-user font-size-16 align-middle me-1"></i> <span key="t-profile">Profile</span></a>
            <a class="dropdown-item" href="#"><i class="bx bx-wallet font-size-16 align-middle me-1"></i> <span key="t-my-wallet">My Wallet</span></a>
            <a class="dropdown-item d-block" href="#"><span class="badge bg-success float-end">11</span><i class="bx bx-wrench font-size-16 align-middle me-1"></i> <span key="t-settings">Settings</span></a>
            <a class="dropdown-item" href="#"><i class="bx bx-lock-open font-size-16 align-middle me-1"></i> <span key="t-lock-screen">Lock screen</span></a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger" href="#"><i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span key="t-logout">Logout</span></a>
        </div>
      </div>
      

    </div>
  </nav>
</template>

<script>
  export default {
    name: "NavHeader",
    props: {
      status: Boolean,
    },

    emits: ['update:status'],
    methods: {
      toggleMenu() {
        this.$emit("update:status", !this.status);
      },

      toggleProfile(){
        const profile = document.querySelector('#profile');
        profile.classList.toggle('show');
      }
    },
  };
</script>

<style lang="scss">
.navbar{
  box-shadow: 0 .75rem 1.5rem rgba(18,38,63,.03);
  background-color: #fff;

  .bx {
    font-size: 1.5rem;
    cursor: pointer;
  }

  .avatar {
    margin-left: auto;
    display: flex;
    align-items: center;
    cursor: pointer;
    
    img {
      margin-left: 1rem;
      margin-right: 1rem;
      border-radius: 50%;
    }

    .profile {
      position: absolute;
      top: 100%;
      right: 1%;
      width: 200px;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0 .75rem 1.5rem rgba(18,38,63,.03);
      padding: 1.5rem;
      opacity: 0;
      visibility: hidden;
      z-index: 100;
      transition: all 0.3s ease-in-out 0s;

    }	

    .show{
      top: 110%;
      opacity: 1;	
      visibility: visible;
    }

  }
}
</style>
